import { Box, Typography } from '@mui/material';

interface Props {
  label: string;
  text: string;
}

function NoteBox({ label, text }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '5px',
        padding: '10px 11px',
        background: 'var(--sidebar-note-bg)',
        border: '1px solid var(--sidebar-hairline)',
        borderRadius: '5px',
      }}>
      <Typography
        sx={{
          fontSize: 'var(--sidebar-font-2xs)',
          fontWeight: 700,
          letterSpacing: '0.04em',
          color: 'var(--sidebar-tertiary)',
        }}>
        {label}
      </Typography>
      <Typography
        sx={{
          fontSize: 'var(--sidebar-font-sm)',
          lineHeight: 1.45,
          color: 'var(--sidebar-body)',
        }}>
        {text}
      </Typography>
    </Box>
  );
}

export default NoteBox;
